@if (localVibrationRecords() != undefined) {
      <div class="d-flex align-items-center gap-2 px-2 pt-2 select-class">
        <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" />
        {{ 'RECORD.SELECT_UNSELECT_ALL' | translate }}
        <div class="ms-auto">
            <button
                *ngIf="selectedRecordIds.size > 0"
                type="button"
                class="tertiary-button delete-multiple-button"
                (click)="deleteSelected()">
                <img src="assets/icon/delete.svg" class="me-1" />
                {{ 'BUTTONS.DELETE' | translate }} ({{selectedRecordIds.size}})
            </button>
        </div>
    </div>
  <div class="scrollable-container text-size">
    @for (record of localVibrationRecords(); track record; let j = $index) {
      <div class="border p-2 m-1 mt-3 text-start rounded-1" style="min-width: 105vh !important;"
        [ngClass]="{ detailledborder: isDetailsVisible()[j] }">
        <div class="row mr-0">
          <div class="pt-4 col-auto">
                <input type="checkbox" [checked]="selectedRecordIds.has(record.id)" (change)="toggleSelection(record.id)" />
            </div>
          <div class="col-8">
            <div class="row mr-0">
              <div class="col-12">
                <div class="row text-start mr-0">
                  <div class="col-3">
                    <div class="text-muted">Timestamp</div>
                    <div>Date: {{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy':'UTC'}}</div>
                    <div>Time: {{record?.recordMetadata.timestamp | date: 'HH:mm:ss':'UTC'}}</div>
                  </div>
                  <div class="col-3">
                    <div class="text-muted">Vibrations (mm/s)</div>
                    <div>
                      <span>
                        V:
                        {{record?.recordMetadata.verticalPpv | number : '1.2-2'}}
                      </span>
                      <span class="ms-2">
                        L:
                        {{record?.recordMetadata.longitudinalPpv | number : '1.2-2'}}
                      </span>
                    </div>
                    <div>
                      <span>
                        T:
                        {{record?.recordMetadata.transversePpv | number : '1.2-2'}}
                      </span>
                      <span class="ms-2">
                        VS: {{record?.recordMetadata.vecSomme | number : '1.2-2'}}
                      </span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="text-muted"> {{'RECORD.AIR_OVERPRESSURE' | translate}}</div>
                    <div>
                      Pa: {{record?.recordMetadata.overpressure | number : '1.2-2' }}
                    </div>
                    <div>
                      dB(L): {{
                      pascalToDecibel(record?.recordMetadata.overpressure) | number : '1.2-2' }}
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="cursor" (click)="openEditNoteModal(j)"> <span class="text-muted"> {{
                    'RECORD.NOTES' | translate }} </span>
                    <img src="assets/icon/edit-pencil.svg" alt="Edit icon"/>
                  </div>
                  <div> {{record?.recordMetadata.note1}}</div>
                  <div> {{record?.recordMetadata.note2}}</div>
                  <div> {{record?.recordMetadata.note3}}</div>
                </div>
              </div>
              <div class="row text-start mt-3 mr-0" >
                @if (isDetailsVisible()[j]) {
                <div class="col-3">
                  <div class="text-muted">PPV max (mm/s)</div>
                  <div>{{ getPicPPVFirstThree(record) | number : '1.2-2' }}
                    ( {{ getMaxFrequencyFirstThree(record) }}
                                    <span>Hz</span> )
                  </div>
                </div>
                <div class="col-3">
                  <div class="cursor" (click)="openEditDistanceModal(j)"> <span class="text-muted"> {{
                  'RECORD.DISTANCE' | translate }} </span>
                  <img src="assets/icon/edit-pencil.svg" alt="Edit icon"/>
                </div>
                <div>{{record?.distance}} m</div>
              </div>
                }
             
            </div>
          </div>
        </div>
      </div>
      <div class="col-3 border-left-line">
        <div class="d-flex me-0">
          <div class="col-10 ">
            <div>
              @if (record?.controlPointId) {
                <div><img src="assets/icon/control-point-black.svg"  alt="control-point icon"/> <span
                  class="ml-1">
                  {{getControlPointName(record?.controlPointId)}}
                </span>
              </div>
            }
            @if (!record?.controlPointId && record?.controlPointId != 0) {
              <div class="opacity-50 text-muted">
                <div class="row d-flex align-items-center mr-0">
                  <div class="col-auto">
                    <img src="assets/icon/question-mark.svg" alt="question icon"/>
                  </div>
                  <div class="col ps-0">
                    <div>{{'RECORD.MEASUREMENT_POINT' | translate}}</div>
                    <div>{{'RECORD.UNASSIGNED' | translate}}</div>
                  </div>
                </div>
              </div>
            }
            <div><img src="assets/icon/device.svg"  alt="device icon"/><span class="ml-1">
              {{record?.recordMetadata.seismographName ??
              record?.recordMetadata.seismographSerialNumber}}
            </span>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div (click)="toggleDetails(j)" class="d-flex justify-content-center cursor">
          <img [src]="isDetailsVisible()[j] ? 'assets/icon/arraw-up.svg' : 'assets/icon/arraw-down.svg'" />
        </div>
      </div>
    </div>
    <div class="row">
      @if (isDetailsVisible()[j]) {
      <div class="d-flex justify-content-start align-items-center gap-2 mt-3 col-10">
        
        @if (record?.recordMetadata.fileName != 'NO_FILE') {
        <button
          type="button"
          class="secondary-button"
          (click)="openFile(record)"
          [disabled]="isDownloading()"
          title="{{ 'BUTTONS.DOWNLOAD' | translate }}">
          <img class="img" src="assets/icon/download.svg" />
        </button>
      }
      </div>
      }

    </div>
  </div>
  @if (isDetailsVisible()[j]) {
    <div class="col-12 mt-2 pr-0">
      <hr class="">
      @if (record != undefined) {
        <div class="row text-size mr-0">
          <div class="col-9" style="position: relative;">
            <div>
              @if (selectedTab === 'main') {
                <div>
                  <app-vibration-chart [siteId]="siteId()"
                  [vibrationRecord]="localVibrationRecords()[j]"
                  [ponderationTypes]="ponderations()"></app-vibration-chart>
                </div>
              }
              @if (selectedTab === 'fft') {
                <div>
                  <span></span>
                </div>
              }
              @if (selectedTab === 'standard') {
                <div>
                  <span></span>
                </div>
              }
              <div class="record-detail">
                <div class="p-2 pl-0">
                  <button type="button" class="tertiary-button"
                    (click)="openConfirmDeleteModal(j)">
                    <i
                    class="fas fas fa-trash" style="padding-right:5px"></i>
                    {{'BUTTONS.DELETE_RECORD' | translate}}
                  </button>
                  <button type="button" class="tertiary-button" (click)="seeRecordOnVibraData(j)">
                    <i
                    class="fas fas fa-eye" style="padding-right:5px"></i>
                    {{'BUTTONS.VIEW_IN_VIBRADATA' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3 border-left-line pl-0 pr-0">
            <button type="button" class="secondary-button w-100" (click)="unassignRecord(record, 'blast')">
                    Unassign from blast
            </button>
            <app-records-assignment
              [isControlPointAssigned]="record.controlPointId != 0 && record.controlPointId != null"
              [vibrationRecord]="record"
              [siteId]="siteId()" [controlPoints]="controlPoints()"
            [deviceRef]="record?.recordMetadata.seismographSerialNumber"></app-records-assignment>
          </div>
        </div>
      }
    </div>
  }
</div>
<div
  bsModal
  #confirmDeleteModal="bs-modal"
  class="modal fade modal-ok-delete"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-child-name"
  [config]="{ backdrop: 'static' }"
  >
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body text-center">
        <p>{{ "GLOBAL.CONFIRMATION_SUPPRESSION" | translate }}</p>
        <button
          type="button"
          class="btn btn-primary"
          (click)="pendingBulkDelete ? executeBulkDelete() : deleteRecord(j)"
          >
          {{ "GLOBAL.OUI" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="pendingBulkDelete = false; confirmDeleteModal.hide()"
          style="margin-left: 20px"
          >
          {{ "GLOBAL.NON" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- modal distance -->
<div
  bsModal
  #editDistanceModal="bs-modal"
  class="modal fade modal-ok-delete"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-child-name"
  [config]="{ backdrop: 'static' }"
  >
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body text-center">
        <h2 class="title mx-auto text-center w-100 fs-5">
          {{ 'RECORD.EDIT_DISTANCE' | translate }}
        </h2>
        <div class="popup-content">
          <form class="form" id="ngForm">
            <div class="d-flex justify-content-between mt-4">
              <div class="row-item-width-100 input-container d-flex flex-column align-items-start">
                <label class="input-label">{{ 'RECORD.DISTANCE' | translate }}</label>
                <input
                  class="input-field"
                  [(ngModel)]="selectedRecordDistance"
                  type="number"
                  [ngModelOptions]="{standalone: true}"
                  />
                </div>
              </div>
            </form>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            (click)="onDistanceEdit(selectedIndex)"
            >
            {{ "GLOBAL.OUI" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="editDistanceModal.hide()"
            style="margin-left: 20px"
            >
            {{ "GLOBAL.NON" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- modal notes -->
  <div
    bsModal
    #editNoteModal="bs-modal"
    class="modal fade modal-ok-delete"
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-child-name"
    [config]="{ backdrop: 'static' }"
    >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body text-center">
          <h2 class="title mx-auto text-center w-100 fs-5">
            {{ 'RECORD.EDIT_NOTES' | translate }}
          </h2>
          <div class="popup-content">
            <form class="form" id="ngForm">
              <div class="d-flex justify-content-between mt-4">
                <div class="row-item-width-100 input-container d-flex flex-column align-items-start">
                  <label class="input-label">{{ 'RECORD.NOTE' | translate }} 1</label>
                  <textarea #inputString  [(ngModel)]="note1" [ngModelOptions]="{standalone: true}" placeholder="Description"
                    class="text-area"  style="width:100%;" rows="3">
                  </textarea>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-4">
                <div class="row-item-width-100 input-container d-flex flex-column align-items-start">
                  <label class="input-label">{{ 'RECORD.NOTE' | translate }} 2</label>
                  <textarea #inputString  [(ngModel)]="note2" [ngModelOptions]="{standalone: true}" placeholder="Description"
                    class="text-area"  style="width:100%;" rows="3">
                  </textarea>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-4">
                <div class="row-item-width-100 input-container d-flex flex-column align-items-start">
                  <label class="input-label">{{ 'RECORD.NOTE' | translate }} 3</label>
                  <textarea #inputString  [(ngModel)]="note3" [ngModelOptions]="{standalone: true}" placeholder="Description"
                    class="text-area"  style="width:100%;" rows="3">
                  </textarea>
                </div>
              </div>
            </form>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            (click)="onNotesEdit(selectedIndex)"
            >
            {{ "GLOBAL.CONFIRMER" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="editNoteModal.hide()"
            style="margin-left: 20px"
            >
            {{ "GLOBAL.ANNULER" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
</div>
}
